import { isAxiosError } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { useApp } from '@/hooks/use-app-context';
import { useToast } from '@/hooks/use-toast';
import {
  audioTextCorrectionErrorKey,
  type AudioTextCorrectionRequest,
  type AudioTextCorrectionResult,
} from './audio-text-correction.contract';
import { correctAudioText } from './audio-text-correction.service';

/** Saves a correction, then hands the stored texts back to the session. */
export function useAudioTextCorrection(onCorrected: (result: AudioTextCorrectionResult) => void) {
  const { t } = useApp();
  const { toast } = useToast();
  const copy = t.audioTextCorrection;

  return useMutation({
    mutationFn: ({ audioId, request }: { audioId: string; request: AudioTextCorrectionRequest }) =>
      correctAudioText(audioId, request),
    onSuccess: (result) => {
      onCorrected(result);
      toast({ title: copy.savedTitle, description: copy.savedDescription });
    },
    onError: (error) => {
      const key = audioTextCorrectionErrorKey(isAxiosError(error) ? error.response?.status : undefined);
      toast({ title: copy.errorTitle, description: copy[key], variant: 'destructive' });
    },
  });
}
